import utmTracking from "./utm-tracking.js";

export default class CampaignSource {
    constructor() { }

    getCampaignSourceValue() {
        var utmCampaign;

        if (utmTracking.utmPresentInUrl()) {
            utmCampaign = utmTracking.getParameterByName("utm_campaign");
        } else {
            utmCampaign = utmTracking.utmCampaign();
        }

        if (!utmCampaign) {
            return "";
        }

        // Both sources are already fully decoded: getParameterByName uses decodeURIComponent,
        // and readCookie (utmCampaign) now unescapes to mirror createCookie's escape. A further
        // decodeURI here would double-decode values, so return as-is.
        return utmCampaign;
    }
}
